
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Component as VC } from 'vue/types/umd';

export interface IItemGroup {
  order?: number;
  key?: string;
  title?: string;
  titleRefId?: string;
  items: Array<string | { component: VC; props: Record<string, any> }>;
}

@Component
export default class FilmInfoTab extends Vue {
  @Prop({ type: Array, default: [] })
  readonly items!: IItemGroup[];
}
